import { datasourcesEditorIdURL } from "ee/RouteBuilder";
import { identifyEntityFromPath } from "navigation/FocusEntity";
import history, { NavigationMethod } from "utils/history";

export function setSelectedDatasource(id?: string) {
  const entityInfo = identifyEntityFromPath(window.location.pathname);

  if (id) {
    history.replace(
      datasourcesEditorIdURL({
        baseModuleId: entityInfo.params?.baseModuleId,
        datasourceId: id,
      }),
      {
        invokedBy: NavigationMethod.ContextSwitching,
      },
    );
  }
}
